import { type FC, Fragment, type MouseEvent } from "react";
import FontAwesomeLight from "../../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import FontAwesomeSolid from "../../../Utilities/Platform/FontAwesome/FontAwesomeSolid";
import {
    type FileConnectionType,
    getFileType,
    MediaItemType,
    type MediaSelectedType,
    MediaType,
} from "./MediaUtilities";

interface Props {
    id: string;
    name: string;
    type: MediaItemType;
    index: number;
    thumbnail?: string;
    extension?: string;
    selected: boolean;
    onClick: (event: MouseEvent, index: number, item: MediaSelectedType) => void;
    navUp?: boolean;
    newFolder?: boolean;
    connections: Array<FileConnectionType>;
    multi?: boolean;
    onToggle?: () => void;
}

export const File: FC<Props> = ({
    id,
    index,
    name,
    type,
    thumbnail,
    extension,
    selected,
    onClick,
    navUp,
    newFolder,
    connections,
    multi,
    onToggle,
}) => {
    const classes = [ "file" ];

    if(selected) {
        classes.push("selected");
    }

    if(newFolder) {
        classes.push("new-folder");
    }

    let media;

    if(type === MediaItemType.Folder) {
        media = (
            <span className="fa-stack">
                <FontAwesomeLight icon="folder" className="fa-stack-1x" />
                {navUp && (
                    <FontAwesomeLight className="sub-icon fa-stack-1x" icon="level-up" />
                )}
                {newFolder && (
                    <FontAwesomeLight className="sub-icon fa-stack-1x" icon="plus" />
                )}
            </span>
        );
    } else {
        let icon = null;

        const type = getFileType(extension);

        if(type === MediaType.Video) {
            icon = <FontAwesomeLight icon="file-video" />;
        } else if(type === MediaType.Image) {
            icon = <FontAwesomeLight icon="file-image" />;
        }

        media = (
            <Fragment>
                <img
                    alt={`Thumbnail for ${thumbnail}`}
                    src={thumbnail}
                    className="media-item"
                />
                <div className="media-type">
                    {icon}
                </div>
                {(multi && typeof onToggle === "function") && (
                    <button
                        type="button"
                        className="media-multi-checkbox"
                        onClick={e => {
                            if(typeof onToggle !== "function") {
                                return;
                            }

                            e.stopPropagation();
                            onToggle();
                        }}
                    >
                        <FontAwesomeSolid icon={selected ? "check-square" : "square"} />
                    </button>
                )}
            </Fragment>
        );
    }

    return (
        <div
            className={classes.join(" ")}
            onClick={e => {
                onClick(e, index, {
                    type,
                    id,
                    name,
                    index,
                });
            }}
        >
            <div className={`media-thumbnail ${type}-item`}>
                {media}
            </div>
            <div className="media-details">
                {connections.length > 0 && (
                    <span className="inline-block mr-1">
                        <FontAwesomeLight icon="paperclip" />
                    </span>
                )}
                {name}
            </div>
        </div>
    );
};
